import { useContext } from 'react';
import {
    Table, TableBody, TableCell, Tooltip, Zoom,
    TableHead, TablePagination, TableRow, IconButton, TableFooter, Typography, Link as MuiLink
} from '@mui/material';
import { SearchOutlined as DetailsIcon } from '@mui/icons-material';
import { shipmentsContext } from '../ShipmentsContext';
import { CircleLoader } from 'components';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';

let Results = () => {
    let service = useContext(shipmentsContext);

    return (
        <div>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={service.handleChangePage}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={(props) => {
                            let pageSize = props.to - props.from + 1
                            return (
                                <>
                                    Total shipments:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                                    <span>Page {props.page + 1} of {Math.ceil(props.count / pageSize)}</span>
                                </>
                            )
                        }}
                    />

                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Shipment id</TableCell>
                                <TableCell>Shipment date</TableCell>
                                <TableCell align='center'>Shipment lines</TableCell>
                                <TableCell>Carrier</TableCell>
                                <TableCell>Tracking</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.shipments.length > 0 &&
                                service.shipments
                                    .map((shipment, index) =>
                                        <TableRow hover key={index}>
                                            <TableCell>{shipment.shipmentId}</TableCell>
                                            <TableCell>
                                                {shipment.shipmentDate != null &&
                                                    <Moment date={shipment.shipmentDate} format="LLL" />
                                                }
                                            </TableCell>
                                            <TableCell align='center'>{shipment.shipmentLines}</TableCell>
                                            <TableCell>{shipment.carrierCode}</TableCell>
                                            <TableCell>
                                                <MuiLink href={shipment.trackingUrl} target='_blank'>
                                                    {shipment.trackingNumber}
                                                </MuiLink>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Tooltip TransitionComponent={Zoom} title="Details">
                                                    <IconButton
                                                        color="primary"
                                                        size="small"
                                                        component={Link}
                                                        to={{ pathname: `/shipment/${shipment.shipmentId}` }}
                                                    >
                                                        <DetailsIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    )}
                        </TableBody>
                        {service.shipments.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <Typography variant="subtitle2">No shipments found</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>

                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={service.handleChangePage}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                    />
                </>
            }
        </div>
    );
}

export default Results;